import moment from 'moment';
import { AppComponent } from './../app.component';
import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { trigger, transition, animate, style, query, stagger } from '@angular/animations';
import { AutenticacionService } from '../servicios/autenticacion.service';
import { Observable, Subscription, timer } from 'rxjs';
import { PerfilesUsuarioService } from "../servicios/perfiles-usuario.service";
import { usersDTO } from '../entidades/entidades.component';
import { Location } from "@angular/common";
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BnNgIdleService } from 'bn-ng-idle';
import { AnalyticsService } from '../servicios/analytics.service';

import { SnackBarComponent } from '../snack-bar/snack-bar.component';
import { MatSnackBar } from '@angular/material/snack-bar';
//import {SharedModule} from '../shared/shared.module';
import { FormsModule } from '@angular/forms'; // Para [(ngModel)]
import { DropdownModule } from 'primeng/dropdown'; // Para <p-dropdown>
import { NbIconModule } from '@nebular/theme'; // Para <nb-icon>
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../spinner/spinner.component';
import { NbCardModule } from '@nebular/theme';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AngularSlickgridModule } from 'angular-slickgrid';
import { NbTabsetModule } from '@nebular/theme';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core'; // necesario para el datepicker
import { NbSelectModule } from '@nebular/theme';
import { NbTreeGridModule } from '@nebular/theme';
import { MultiSelectModule } from 'primeng/multiselect';
import { MatIconModule } from '@angular/material/icon';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';

import { MatCheckboxModule } from '@angular/material/checkbox';
import { NbOptionModule } from '@nebular/theme';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    animations: [
        trigger('pageAnimations', [
            transition(':enter', [
                query('.hero, form', [
                    style({ opacity: 0, transform: 'translateY(-100px)' }),
                    stagger(-30, [
                        animate('500ms cubic-bezier(0.35, 0, 0.25, 1)', style({ opacity: 1, transform: 'none' }))
                    ])
                ])
            ])
        ]),
        trigger('slideInOut', [
            transition(':enter', [
                style({ transform: 'translateY(-100%)' }),
                animate('650ms ease-in', style({ transform: 'translateY(0%)' }))
            ]),
            transition(':leave', [
                animate('650ms ease-in', style({ transform: 'translateY(-100%)' }))
            ])
        ]),
        trigger('filterAnimation', [
            transition(':enter, * => 0, * => -1', []),
            transition(':increment', [
                query(':enter', [
                    style({ opacity: 0, width: '0px' }),
                    stagger(50, [
                        animate('300ms ease-out', style({ opacity: 1, width: '*' })),
                    ]),
                ], { optional: true })
            ]),
            transition(':decrement', [
                query(':leave', [
                    stagger(50, [
                        animate('300ms ease-out', style({ opacity: 0, width: '0px' })),
                    ]),
                ])
            ]),
        ]),
    ],
    standalone: true,
    imports: [MatButtonModule,ReactiveFormsModule,SpinnerComponent,
       FormsModule, MatIconModule, CommonModule, NbCardModule, 
       NbIconModule, DropdownModule, MatCardModule, MatFormFieldModule, 
       MatInputModule, AngularSlickgridModule, NbTabsetModule, MatDatepickerModule, 
       MatNativeDateModule, NbSelectModule, NbTreeGridModule, MultiSelectModule,
      MatCheckboxModule,
    NbOptionModule ],
    providers: [DatePipe],
})
export class LoginComponent implements OnInit {
  @ViewChild('tmpChooseClient') private templateRefChooseClient: TemplateRef<any>;
  @ViewChild('termsConditions') private templateTermsConditions: TemplateRef<any>;
  modalRef: BsModalRef;
  clientes = [];
  clienteSelected;
  loadingResponse = false;
  hide = true;

  hidePassword = false;
  checkEmail = false;
  snackBar = false;
  customSnackBarMsg = ''

  mensajeErrorLogin: string;
  mensaje: string;
  user: string;
  passEncr: string;
  loginForm: UntypedFormGroup;
  options: UntypedFormGroup;
  subscription: Subscription;
  datosUsuario;
  checkTermsConditions: boolean = false;
  timer: Observable<any>;
  usuarioLog = false;
  tiempoInactividad: number = 300;

  constructor(private fb: UntypedFormBuilder, private router: Router, private app: AppComponent,
    private svrAuth: AutenticacionService, private modalService: BsModalService,
    private usersRoles: PerfilesUsuarioService, private location: Location,
    private bnIdle: BnNgIdleService, private svcAnalytics: AnalyticsService) {
    this.options = fb.group({
      hideRequired: false,
      floatLabel: 'auto',
    });

    // SE IMPLEMENTARÁ EL SIGUIENTE MÉTODO PARA LA VERSIÓN 1.0.6
    // ---------------------------------------------------------
    //se expresa en segundos

    this.listenActivity(this.tiempoInactividad);
  }

  validation_messages_login = {
    'usuario': [
      { type: 'required', message: 'Debe ingresar un usuario' }
    ],
    'contrasena': [
      { type: 'required', message: 'Debe ingresar la contraseña' }
    ]
  };
  get loginData() { return this.loginForm.controls; }

  ngOnInit() {
    this.createForm();
    this.sessionAbierta();
  }

  listenActivity(tiempoInactividad) {
    if (this.usuarioLog) {
      this.bnIdle.startWatching(tiempoInactividad).subscribe((res) => {
        if (res) {
          localStorage.removeItem('currentUser');
          localStorage.removeItem('activeDirectoryUser');
          localStorage.removeItem('permits');
          this.cerrarSession();
          window.location.reload();
          // alert("Sesión finalizada por inactividad");
        }
      });
    }
  }

  sessionAbierta() {
    let usuarioLogeado = localStorage.getItem('token');
    if (usuarioLogeado != undefined && usuarioLogeado != null) {
      let dia = moment(new Date());
      if (dia.diff(localStorage.getItem('timeToken'), 'hour') < 2) {
        this.user = localStorage.getItem('username')
        this.passEncr = localStorage.getItem('pass')
        this.getUsername(this.user);
      }
    }
    else {
      this.cerrarSession();
    }
  }
  createForm() {
    this.loginForm = this.fb.group({
      usuario: ['', Validators.required],
      contrasena: ['', Validators.required],
    });
  }
  validar() {
    this.user = this.loginData.usuario.value;
    this.passEncr = window.btoa(this.loginData.contrasena.value);
    this.autenticar(this.user, this.passEncr);
  }
  autenticar(user: string, pass: string) {
    this.loadingResponse = true;
    this.svrAuth.autenticar(user, pass).subscribe(
      data => {
        if (data != null) {
          let fechaToken = new Date();
          localStorage.setItem('token', data['jwtToken'].toString().replace('Bearer', ''));
          localStorage.setItem('timeToken', moment(fechaToken, 'DD/MM/yyyy HH:mm:ss').toString());
          this.timer = timer(3000)
          this.subscription = this.timer.subscribe(() => {
            this.getUsername(this.user);
            this.usuarioLog = true;
            this.listenActivity(this.tiempoInactividad);
            //gtag de Login
            this.svcAnalytics.setAnalyticsLoginButton(user);
          })
        }
        else {
          this.permisoIngreso('Usuario y/o Contraseña incorrectos');
        }
      }, error => {
        this.permisoIngreso('Usuario y/o Contraseña incorrectos');
      }
    );
  }
  getUsername(Username) {
    this.svrAuth.getUsername(Username).subscribe(
      data => {
        var permisosRoles: usersDTO;
        permisosRoles = {
          id: data["id"],
          username: data["username"],
          nombre: data["nombre"],
          apellido: data["apellido"],
          correoElectronico: data["correoElectronico"],
          perfil: {
            id: data["perfil"].id,
            descripcion: data["perfil"].descripcion,
            operador: data["perfil"].operador,
            cliente: data["perfil"].cliente,
            perfilRoles: data["perfil"]["perfilRoles"]
          },
          operador: {
            id: data["operador"].id,
            descripcion: data["operador"].descripcion,
          },
          clientes: [
            {
              id: data["clientes"].id,
              descripcion: data["clientes"].descripcion,
            }
          ]

        }
        this.usersRoles.verificarRoles(permisosRoles);
        this.datosUsuario = data;
        this.setDatosUsuario();
        if (this.datosUsuario.terminosYCondiciones == false) {
          this.openTermsConditions();
        } else {
          this.openElegirCliente(this.datosUsuario['clientes']);
          this.svrAuth.USUARIO_LISTACLIENTES = data["clientes"]
          this.svrAuth.USUARIO_OPERADORLOGGED = data["operador"]
        }
        //gtag trackeoID
        this.svcAnalytics.setAnalyticsUserIdTracker(permisosRoles.id);
      })
  }
  setDatosUsuario() {
    localStorage.setItem('nombre', this.datosUsuario['nombre']);
    localStorage.setItem('apellido', this.datosUsuario['apellido']);
    localStorage.setItem('operador', this.datosUsuario['operador'].descripcion);
    localStorage.setItem('idOperador', this.datosUsuario['operador'].id);
    localStorage.setItem('esCliente', this.datosUsuario['operador'].id == null ? 'true' : 'false');
    localStorage.setItem('username', this.datosUsuario['username']);
    localStorage.setItem('pass', this.passEncr);
    localStorage.setItem('idTipoOperador', this.datosUsuario['idTipoOperador']);
    localStorage.setItem('perfil', this.datosUsuario['perfil'].descripcion);
  }
  openElegirCliente(arrCli) {
    if (arrCli.length == 1) {
      localStorage.setItem('idCliente', this.datosUsuario['clientes'][0].id);
      localStorage.setItem('cliente', this.datosUsuario['clientes'][0].descripcion);
      this.permisoIngreso("OK");
    } else {
      this.clientes = [];
      this.datosUsuario['clientes'].forEach(e => {
        this.clientes.push({
          value: e.id,
          label: e.descripcion
        })
      });

      this.modalRef = this.modalService.show(this.templateRefChooseClient, { class: 'modal-lg' });
      this.modalRef.onHide.subscribe(n => {
        this.loadingResponse = false;
      })
    }
  }
  elegirCliente() {
    let seleccionado;
    seleccionado = this.clientes.find(n => n.value == this.clienteSelected);
    localStorage.setItem('idCliente', seleccionado.value);
    localStorage.setItem('cliente', seleccionado.label);
    this.permisoIngreso("OK");
  }
  hideConfirm() {
    this.loadingResponse = false;
    this.modalRef.hide();
  }

  //ABRE EL POPUP TÉRMINOS Y CONDICIONES
  openTermsConditions() {
    this.modalRef = this.modalService.show(this.templateTermsConditions, { class: 'modal-lg' });
    this.modalRef.onHide.subscribe(n => {
      this.loadingResponse = false;
    })
  }
  //MÉTODO PARA EL BOTÓN ACEPTAR DE TÉRMINOS Y CONDICIONES
  savetermsConditions() {
    this.svrAuth.getTermsConditions(this.user).subscribe(data => {
      this.checkTermsConditions = true;
      if (this.checkTermsConditions == true) {
        this.hideConfirmTerms();
        this.openElegirCliente(this.datosUsuario['clientes']);
        this.svrAuth.USUARIO_LISTACLIENTES = data["clientes"]
        this.svrAuth.USUARIO_OPERADORLOGGED = data["operador"]
      }
      this.checkTermsConditions = false;
    })
  }

  //BOTÓN CANCELAR TÉRMINOS Y CONDICIONES
  hideConfirmTerms() {
    this.permisoIngreso('');
    this.loadingResponse = false;
    this.checkTermsConditions = false;
    this.modalRef.hide();
  }

  permisoIngreso(dataUserResponse: string) {
    this.loadingResponse = false;
    if (dataUserResponse === 'OK') {
      if (this.modalRef) {
        this.modalRef.hide();
      }
      this.app.ingreso = true;
    } else {
      this.mensajeErrorLogin = dataUserResponse;
    }
  }

  cerrarSession() {
    localStorage.removeItem("token");
    localStorage.removeItem("cliente");
    localStorage.removeItem("idCliente");
    localStorage.removeItem('nombre');
    localStorage.removeItem('apellido');
    localStorage.removeItem('operador');
    localStorage.removeItem('idOperador');
    localStorage.removeItem('username');
    localStorage.removeItem('pass');
    localStorage.removeItem('timeToken');
    localStorage.removeItem('idTipoOperador');
    localStorage.removeItem('tk_vca');
    localStorage.removeItem('esCliente');
    localStorage.removeItem('perfil');
    this.usuarioLog = false;
    this.app.ingreso = false;
    this.router.navigate([''])//#
  }

  // HABILITA EL RECUPERO DE CONTRASEÑA
  toggleForgotPassWord() {
    this.hidePassword = true
  }

  forgotPassword() {
    this.hidePassword = false
    this.user = this.loginData.usuario.value
    this.svrAuth.sendEmailForgotPassword(this.user).subscribe(() => {
      this.openCustomSnackBar('Verifica tu email')
      // alert('Verifica tu email')
    }, e => {
      // alert(e.error.errors[0].message)
      // alert('Ya generaste un recupero en los últimos 30 minutos')
      this.openCustomSnackBar('Ya generaste un recupero en los últimos 30 minutos')
    })
  }

  openCustomSnackBar(mensaje: string) {
    this.snackBar = true
    this.customSnackBarMsg = mensaje
    timer(4000).subscribe(() => {
      this.snackBar = false
    })
  }
}

